(() => {
  if (document.documentElement.lang.toLowerCase().split('-')[0] === 'en') return;

  const selector = [
    '.image-text__heading',
    '.collection-highlight__heading',
    '.our-curations__title',
    '.fullscreen-menu__mobile-card-title',
    '.finer-details__panel-heading',
    '.finer-details__layer-title'
  ].join(',');
  const originalSizes = new WeakMap();
  const observedWidths = new WeakMap();
  const observedParents = new WeakSet();
  let pending = false;

  const fit = (element) => {
    if (!element.clientWidth) return;
    if (!originalSizes.has(element)) originalSizes.set(element, element.style.fontSize);
    element.style.fontSize = originalSizes.get(element);

    const style = getComputedStyle(element);
    const size = parseFloat(style.fontSize);
    const parent = element.parentElement;
    const parentStyle = getComputedStyle(parent);
    const available = parent.clientWidth - parseFloat(parentStyle.paddingLeft) - parseFloat(parentStyle.paddingRight);
    if (available <= 0 || !Number.isFinite(size)) return;
    const ranges = [];
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      for (const word of node.textContent.matchAll(/[^\s\u200b-]+/g)) {
        const range = document.createRange();
        range.setStart(node, word.index);
        range.setEnd(node, word.index + word[0].length);
        ranges.push(range);
      }
    }
    let currentSize = size;
    for (let attempt = 0; attempt < 4; attempt++) {
      const widest = Math.max(0, ...ranges.map(range =>
        Array.from(range.getClientRects()).reduce((width, rect) => width + rect.width, 0)
      ));
      if (widest <= available - 1) break;
      currentSize = Math.floor(currentSize * (available - 1) / widest * 100) / 100;
      element.style.fontSize = `${currentSize}px`;
    }
  };

  const observer = new ResizeObserver(entries => {
    let changed = false;
    entries.forEach(entry => {
      const width = entry.contentRect.width;
      if (observedWidths.get(entry.target) !== width) {
        observedWidths.set(entry.target, width);
        changed = true;
      }
    });
    if (changed) schedule();
  });

  const update = () => {
    pending = false;
    document.querySelectorAll(selector).forEach(element => {
      fit(element);
      const parent = element.parentElement;
      if (parent && !observedParents.has(parent)) {
        observedParents.add(parent);
        observer.observe(parent);
      }
    });
  };

  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  };

  schedule();
  document.fonts.ready.then(schedule);
  document.fonts.addEventListener('loadingdone', schedule);
  window.addEventListener('resize', schedule);
  document.addEventListener('toggle', schedule, true);
  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest('fullscreen-menu, .finer-details')) schedule();
  });
  document.addEventListener('shopify:section:load', schedule);
})();
